import { useEffect } from "react";
import logger from "../Components/Logger";

// This component loads the Elfsight chatbot script and renders the chatbot widget and translated by ChatGPT
// from Html to React components
// Link : https://dash.elfsight.com/apps/ai-chatbot

export default function ElfsightChatbot() {
  useEffect(() => {
    // Prevent loading the script multiple times 
    const existingScript = document.querySelector(
      'script[src="https://elfsightcdn.com/platform.js"]'
    );
    
    if (existingScript) {
      logger.info("Elfsight chatbot script is already loaded.");
      return;
    }

    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="elfsight-app-40696334-1507-4b70-b616-1875574b58db"
      data-elfsight-app-lazy="true"
    />
  );
}